import { FC, SVGProps } from 'react';

const AIAnalyticsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 20,
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7.33398 9.74292V17.066M11.5337 15.0377V17.0658M15.6651 13.1659V17.0655"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.801 3.5H7.36626C4.42691 3.5 2.58313 5.58119 2.58313 8.52735V16.4736C2.58313 19.4198 4.41816 21.5 7.36626 21.5H15.8C18.7491 21.5 20.5832 19.4198 20.5832 16.4736V13.5274"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9874 8.69899L18.0884 8.42561C18.4693 7.39482 19.2808 6.58209 20.3101 6.20066L20.583 6.09951L20.3101 5.99835C19.2808 5.61692 18.4693 4.8042 18.0884 3.7734L17.9874 3.5L17.8864 3.7734C17.5055 4.8042 16.694 5.61692 15.6647 5.99835L15.3917 6.09951L15.6647 6.20066C16.694 6.58209 17.5055 7.39482 17.8864 8.42561L17.9874 8.69899Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6767 9.94113C12.8483 9.37647 13.2895 8.93455 13.8533 8.76268C13.2895 8.59082 12.8483 8.1489 12.6767 7.58423C12.5051 8.1489 12.0638 8.59082 11.5 8.76268C12.0638 8.93455 12.5051 9.37647 12.6767 9.94113Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AIAnalyticsIcon;
